import styled from "styled-components";

export const ReferralFormWrapper = styled.div`
  display: ${props => props.checked ? "block" : "none"};
`;
